/* ============================================================
   MCH — SIGNAL · product page
   gallery · size picker · ATC · sticky bar · review modal
   ============================================================ */
(() => {
  'use strict';

  const root = document.querySelector('.js-pdp');
  if (!root) return;

  const cfgEl = document.querySelector('[data-pdp-config]');
  const cfg = cfgEl ? JSON.parse(cfgEl.textContent) : { variants: [] };

  /* ---------------- gallery ---------------- */
  const mainImg = root.querySelector('.js-pdp-img');
  const thumbs = [...root.querySelectorAll('.js-pdp-thumb')];
  thumbs.forEach((t) => {
    t.addEventListener('click', () => {
      thumbs.forEach((x) => x.classList.remove('is-on'));
      t.classList.add('is-on');
      const src = t.dataset.full;
      const srcset = t.dataset.fullSrcset || '';
      const viewer = root.querySelector('.js-pdp-3d');
      if (t.dataset.kind === '3d' && viewer) {
        viewer.hidden = false;
        if (mainImg) mainImg.hidden = true;
        return;
      }
      if (viewer) viewer.hidden = true;
      if (mainImg) {
        mainImg.hidden = false;
        mainImg.classList.remove('is-swap');
        void mainImg.offsetWidth;
        mainImg.src = src;
        if (srcset) mainImg.srcset = srcset;
        mainImg.classList.add('is-swap');
      }
      syncModelBadge(t);
    });
  });

  // model-info badge follows the displayed photo; a photo can feature
  // several models, each with their own height/size (multi-model metafield)
  const modelBadge = root.querySelector('.js-model-badge');
  const modelData = (() => {
    try { return JSON.parse((root.querySelector('.js-model-data') || {}).textContent || '[]'); }
    catch (e) { return []; }
  })();
  function syncModelBadge(thumb) {
    if (!modelBadge) return;
    const pos = thumb ? parseInt(thumb.dataset.pos, 10) : NaN;
    const hits = modelData.filter((m) => m && m.h && m.s && Array.isArray(m.on) && m.on.includes(pos));
    if (!hits.length) { modelBadge.hidden = true; return; }
    modelBadge.querySelector('.js-model-txt').textContent = hits.length === 1
      ? `Model je visine ${hits[0].h} cm i nosi našu ${hits[0].s} veličinu`
      : hits.map((m) => `${m.h} cm nosi ${m.s}`).join('  ·  ');
    modelBadge.hidden = false;
  }
  syncModelBadge(root.querySelector('.js-pdp-thumb.is-on'));

  /* ---------------- size chart pop-up ---------------- */
  const szModal = root.querySelector('.js-szmodal');
  if (szModal) {
    const szOpen = () => {
      szModal.classList.add('is-open');
      szModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
    };
    const szClose = () => {
      szModal.classList.remove('is-open');
      szModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
    };
    root.querySelectorAll('[data-sizes-open]').forEach((b) => b.addEventListener('click', szOpen));
    szModal.addEventListener('click', (e) => {
      if (e.target.closest('[data-overlay-close]')) szClose();
    });
    addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && szModal.classList.contains('is-open')) szClose();
    });
  }

  /* ---------------- size chart tabs ---------------- */
  root.querySelectorAll('.js-sizes').forEach((box) => {
    box.addEventListener('click', (e) => {
      const tab = e.target.closest('.js-sizes-tab');
      if (!tab) return;
      box.querySelectorAll('.js-sizes-tab').forEach((t) => t.classList.toggle('is-on', t === tab));
      box.querySelectorAll('.js-sizes-panel').forEach((p) => { p.hidden = p.dataset.chart !== tab.dataset.chart; });
    });
  });

  /* ---------------- gallery arrows ---------------- */
  function stepGallery(dir) {
    const onIdx = thumbs.findIndex((t) => t.classList.contains('is-on'));
    if (onIdx < 0 || !thumbs.length) return;
    const next = (onIdx + dir + thumbs.length) % thumbs.length;
    thumbs[next].click();
    thumbs[next].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  }
  const prevBtn = root.querySelector('.js-pdp-prev');
  const nextBtn = root.querySelector('.js-pdp-next');
  prevBtn && prevBtn.addEventListener('click', () => stepGallery(-1));
  nextBtn && nextBtn.addEventListener('click', () => stepGallery(1));

  /* ---------------- variant state ---------------- */
  const sizeBtns = [...root.querySelectorAll('.js-size')];
  const qtyInput = root.querySelector('.js-qty');
  const atcBtns = [...document.querySelectorAll('.js-atc')];
  const priceEls = [...document.querySelectorAll('.js-pdp-price')];
  const stockEl = root.querySelector('.js-pdp-stock');
  let current = cfg.variants.find((v) => v.id === cfg.selected) || cfg.variants[0] || null;

  function fmt(cents) { return window.MCH ? window.MCH.money(cents) : Math.round(cents / 100) + ' RSD'; }

  function renderState() {
    if (!current) return;
    priceEls.forEach((el) => {
      let html = fmt(current.price);
      if (current.compare_at && current.compare_at > current.price) {
        html = `<s>${fmt(current.compare_at)}</s> ${fmt(current.price)}`;
      }
      el.innerHTML = html;
    });
    atcBtns.forEach((b) => {
      b.disabled = !current.available;
      b.querySelector('span') && (b.querySelector('span').textContent = current.available ? b.dataset.labelAdd : 'Rasprodato');
    });
    if (stockEl) {
      stockEl.classList.remove('is-low', 'is-out');
      if (!current.available) {
        stockEl.classList.add('is-out');
        stockEl.textContent = 'Trenutno rasprodato';
      } else if (current.qty > 0 && current.qty <= 5) {
        stockEl.classList.add('is-low');
        stockEl.textContent = `Na stanju je još ${current.qty} kom`;
      } else {
        stockEl.textContent = 'Na stanju';
      }
    }
  }

  sizeBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      sizeBtns.forEach((x) => x.classList.remove('is-on'));
      btn.classList.add('is-on');
      const id = parseInt(btn.dataset.variant, 10);
      current = cfg.variants.find((v) => v.id === id) || current;
      renderState();
      history.replaceState(null, '', `${location.pathname}?variant=${id}`);
    });
  });
  renderState();

  /* ---------------- qty ---------------- */
  root.querySelectorAll('.js-qty-plus').forEach((b) => b.addEventListener('click', () => {
    qtyInput.value = Math.min(99, (parseInt(qtyInput.value, 10) || 1) + 1);
  }));
  root.querySelectorAll('.js-qty-minus').forEach((b) => b.addEventListener('click', () => {
    qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
  }));

  /* ---------------- add to cart ---------------- */
  atcBtns.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      if (!current || !current.available) return;
      if (btn.classList.contains('is-busy')) return;   // double-tap = double add
      const q = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      const span = btn.querySelector('span');
      const orig = span ? span.textContent : '';
      btn.classList.add('is-busy');
      if (span) span.textContent = 'Dodajem…';
      window.MCHcart.add({ id: current.id, quantity: q })
        .then(() => { if (span) span.textContent = '✓ U korpi'; })
        .catch((err) => {
          window.MCHtoast && window.MCHtoast(`<span class="err">✕</span> ${err.message}`);
          if (span) span.textContent = orig;
        })
        .finally(() => {
          btn.classList.remove('is-busy');
          setTimeout(() => { if (span && span.textContent === '✓ U korpi') span.textContent = orig; }, 2200);
        });
    });
  });

  /* ---------------- sticky mobile bar ---------------- */
  const bar = document.querySelector('.js-pdp-bar');
  const buyBox = root.querySelector('.pdp__actions');
  if (bar && buyBox) {
    new IntersectionObserver(([en]) => {
      bar.classList.toggle('is-show', !en.isIntersecting && en.boundingClientRect.top < 0);
    }).observe(buyBox);
  }

  /* ---------------- review modal ---------------- */
  const modal = document.querySelector('.js-rmodal');
  if (modal) {
    const openBtns = [...document.querySelectorAll('[data-review-open]')];
    const form = modal.querySelector('.js-rmodal-form');
    const err = modal.querySelector('.js-rmodal-err');
    const stars = [...modal.querySelectorAll('.rmodal__star')];
    const ratingInput = modal.querySelector('.js-rmodal-rating');
    let tsToken = '', tsRendered = false;

    const open = () => {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
      loadTurnstile();
    };
    const close = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('no-scroll');
    };
    openBtns.forEach((b) => b.addEventListener('click', open));
    modal.addEventListener('click', (e) => {
      if (e.target.closest('[data-overlay-close]') || e.target.classList.contains('rmodal__scrim')) close();
    });
    addEventListener('keydown', (e) => { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });

    stars.forEach((s, i) => s.addEventListener('click', () => {
      ratingInput.value = i + 1;
      stars.forEach((x, j) => x.classList.toggle('is-on', j <= i));
    }));

    function loadTurnstile() {
      const box = modal.querySelector('.js-rmodal-ts');
      if (!cfg.turnstileKey || tsRendered || !box) return;
      const render = () => {
        if (tsRendered) return;
        tsRendered = true;
        window.turnstile.render(box, {
          sitekey: cfg.turnstileKey,
          theme: 'light',
          callback: (t) => { tsToken = t; },
          'expired-callback': () => { tsToken = ''; },
        });
      };
      if (window.turnstile) return render();
      const s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=__mchTs';
      window.__mchTs = render;
      document.head.appendChild(s);
    }

    form && form.addEventListener('submit', async (e) => {
      e.preventDefault();
      err.hidden = true;
      if (!ratingInput.value) { err.textContent = 'Klikni na zvezdice i oceni.'; err.hidden = false; return; }
      if (cfg.turnstileKey && !tsToken) { err.textContent = 'Štrikliraj „nisam robot" pa šaljemo.'; err.hidden = false; return; }
      const btn = form.querySelector('button[type="submit"]');
      btn.disabled = true; btn.querySelector('span').textContent = 'Šaljem…';
      try {
        const fd = new FormData(form);
        fd.append('productId', cfg.productId);
        fd.append('turnstileToken', tsToken);
        const res = await fetch(cfg.reviewEndpoint, { method: 'POST', body: fd });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data.ok) throw new Error(data.error || 'Slanje nije uspelo. Probaj kasnije.');
        modal.classList.add('is-done');
      } catch (ex) {
        err.textContent = ex.message; err.hidden = false;
        if (window.turnstile && tsRendered) { try { window.turnstile.reset(); } catch {} tsToken = ''; }
      } finally {
        btn.disabled = false; btn.querySelector('span').textContent = 'Pošalji recenziju';
      }
    });
  }
})();
